export const SALE_AVAILABLE = 'DISPONIBLE PARA LA VENTA';
//export const SALE_AVAILABLE = 'DISPONIBLE PARA LA VENTA';


// WEBPACK FOOTER //
// ./src/constants/saleorderConstants.js